import { FormattedMessage } from 'react-intl';
import css from './SafetyPriority.module.css';

const SafetyPriority = () => {
  return (
    <section className={css.safetySection}>
      <div className={css.safetyContent}>
        <div className={css.safetyImage}>
            <img src="https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=1000"/>
        </div>
        <div className={css.safetyText}>
          <div className={css.innerText}>
               <h3 className={css.safetyTitle}>
                  <FormattedMessage id="LandingPage.Safety.title" />
                </h3>
                <p className={css.safetyDescription}>
                  <FormattedMessage id="LandingPage.Safety.description" />
                </p>
                <button className={css.ctaBtn}>
                  <FormattedMessage id="LandingPage.Safety.cta" />
                </button>
          </div>
         
        </div>
      </div>
    </section>
  );
};

export default SafetyPriority;
